const firebaseConfig = {
    apiKey: "AIzaSyBoMsn7VAomzg71KgD8sDnYGHqEEkHEEAU",
  authDomain: "car-service-36e1f.firebaseapp.com",
  projectId: "car-service-36e1f",
  storageBucket: "car-service-36e1f.appspot.com",
  messagingSenderId: "1020215796323",
  appId: "1:1020215796323:web:f937220794752d00da0e56"
};

export default firebaseConfig;